import { useEffect } from 'react';

const TawkTo = () => {
    useEffect(() => {
        // Initialize Tawk_API
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();

        // Create and inject the Tawk.to script
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://embed.tawk.to/69201fb38c9683195b70e517/1jainnljl';
        script.charset = 'UTF-8';
        script.setAttribute('crossorigin', '*');

        // Insert the script into the document
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);

        // Cleanup function to remove the script when component unmounts
        return () => {
            // Remove the script element
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }

            // Remove Tawk.to widget
            const tawkWidget = document.getElementById('tawkchat-container');
            if (tawkWidget) {
                tawkWidget.remove();
            }
        };
    }, []);

    return null; // This component doesn't render anything
};

export default TawkTo;
